import React, { useState, useRef } from "react";

import { Link } from "react-router-dom";

import { FaUserAlt } from "react-icons/fa";
import { BiChevronDown } from "react-icons/bi";

import { deleteAllCookies, getCookie } from "../utility/Cookie";


const UserOption = () => {
  const [loading, setLoading] = useState(true);
  const [user] = useState(JSON.parse(getCookie("_g_")));

  const openMenu = useRef(null);

  const handleLogout = () => {
    setLoading(false)
    fetch(`${process.env.REACT_APP_BASE_URL}/logout`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((data) => data.json())
      .then((res) => {
        if (res.status === "success") {
          window.location.href = "/";
          setLoading(true)
        }
      });
    localStorage.removeItem("token");
    localStorage.removeItem("_g_user");
    deleteAllCookies();
    window.location.href = "/";
  };

  const handleClick = () => {
    openMenu.current.classList.toggle("options-active");
  };

  if (!loading) {
    return (
      <div className="navItem nav-right">
        <div className="lds-dual-ring"></div>
      </div>
    );
  }

  return (
    !loading ?
      <div className="navItem nav-right">
        <div className="lds-dual-ring"></div>
      </div>
      :
      <li className="navItem nav-right">
        <div className="user-option">
          <div className="user-item" onClick={handleClick}>
            <div className="user-after">
              <FaUserAlt />
            </div>
            <h6>
              {user?.first_name} {user?.last_name}
            </h6>
            <div className="caret-down">
              <BiChevronDown />
            </div>
          </div>
          <div className="menu-options" ref={openMenu}>
            <div className="menu-options-item">
              <div className="option">
                <Link to="/settings">Settings</Link>
              </div>
              <div className="option">
                <Link to="/my-courses">My courses</Link>
              </div>
              <div className="option">
                <Link to="/accomplishments">Accomplishments</Link>
              </div>
              <div className="option">
                <div
                  role="button"
                  aria-label="logOut"
                  className="option-logOut"
                  onClick={handleLogout}
                >
                  Log Out
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
  );
};

export default UserOption;
